import {filterMap} from '@benchling/js-utils';

import {Grid, GridSummary} from 'constants/SampleConstants';
import StorableStore from 'samples/StorableStore';
import APIUtil from 'util/APIUtil';

export type GridsById = (typeof StorableStore)['grids'];
export type GridSummariesById = (typeof StorableStore)['gridSummaries'];

function compactedMapOfType<T extends {id?: string}>(
  objs: {[id: string]: T | null},
  apiType: string
): {[id: string]: T} {
  return filterMap(
    objs,
    (g: T | null) => g != null && typeof g.id === 'string' && APIUtil.apiIdToType(g.id) === apiType
  ) as {
    [id: string]: T;
  };
}

// The StorableStore will put an {isLoading: true|false} object into the store in place of
// a grid while they are loading (see GRID_UPDATE_STARTED), and some values may also be null.
// So we need to filter to non-null objects that actually have an id on them.
export function gridsFromStoreToValidMapOfType<TGrid extends Grid>(
  gridsFromStore: GridsById,
  gridType: string
): {[id: string]: TGrid} {
  return compactedMapOfType(gridsFromStore, gridType) as {[id: string]: TGrid};
}

export function gridSummariesFromStoreToValidMapOfType<TGrid extends GridSummary>(
  gridsFromStore: GridSummariesById,
  gridType: string
): {[id: string]: TGrid} {
  return compactedMapOfType(gridsFromStore, gridType) as {[id: string]: TGrid};
}
